import { Block, Ico, Title, SubTitle } from "./styled";

const GitHubHeader = () => {
    return (
        <Block>
            <Ico />
            <Title>Portfolio</Title>
            <SubTitle>My recent GitHub projects</SubTitle>
        </Block>
    )
};

export default GitHubHeader;